import {DateTimeFormatter, LocalDate as LocalDate, LocalDateTime, Duration} from "@js-joda/core";
LocalDate.LocalDate;


let addIntForDate = (num) => num >= 10 ? num : '0' + num;

function formatCustomDateTime(dateTime, pattern) {
    const day = addIntForDate(dateTime.dayOfMonth());
    const month = addIntForDate(dateTime.monthValue());
    const year = dateTime.year();
    const hour = addIntForDate(dateTime.hour());
    const minute = addIntForDate(dateTime.minute());
    const second = addIntForDate(dateTime.second());

    switch (pattern) {
        case "yyyy-MM-dd HH:mm:ss":
            return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
        case "E dd MMM, HH:ss":
            return `${dateTime.dayOfWeek().name().substring(0, 3)} ${day} ${dateTime.month().name().substring(0, 3)}, ${hour}:${minute}`;
        case "dd/MM/yyyy, HH:ss":
            return `${day}/${month}/${year}, ${hour}:${minute}`;
        case "HH:mm":
            return `${hour}:${minute}`;
        default:
            throw new Error("Unsupported pattern");
    }
}

const defaultFormat = "yyyy-MM-dd HH:mm:ss";
const thisYearFormat = "E dd MMM, HH:mm";
const otherYearFormat ="dd/MM/yyyy, HH:mm";
const todayFormat = "HH:mm";

class TimeRangeManager {

    shortenDisplay(parsedDate) {
        if (!parsedDate) return `Invalid Date : ${parsedDate}`
        let formattedDate = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"));
        let now = LocalDateTime.now();
        if (formattedDate.toLocalDate().equals(now.toLocalDate())) {
            return `Today at ` + formatCustomDateTime(formattedDate, "HH:mm");
        } else if (formattedDate.toLocalDate().year() === now.toLocalDate().year()) {
            return formatCustomDateTime(formattedDate, "E dd MMM, HH:ss");
        } else {
            return formatCustomDateTime(formattedDate, "dd/MM/yyyy, HH:ss");
        }
    }

    shortJavaDateTimeObject(javaDateTimeObject) {
        let date = javaDateTimeObject.date;
        let time = javaDateTimeObject.time;
        let parsedDate = `${date.year}-${addIntForDate(date.month)}-${addIntForDate(date.day)} ${addIntForDate(time.hour)}:${addIntForDate(time.minute)}:${addIntForDate(time.minute)}`;
        return this.shortenDisplay(parsedDate);
    }

    getNow() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        return today;
    }

    getThisMoment() {
        let date = LocalDateTime.now().format(DateTimeFormatter.ofPattern("yyyy-MM-dd"));
        let time = LocalDateTime.now().format(DateTimeFormatter.ofPattern("hh:mm"));
        return date+`T`+time;
    }

    getNowMinusDays(days) {
        let today = LocalDate.now().minusDays(days);
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);
        return today;
    }

    getToday() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);

        return {from: today, to: tomorrow}
    }

    getYesterday() {
        let today = LocalDate.now();
        today = today._year + '-' + addIntForDate(today._month) + '-' + addIntForDate(today._day);

        let yesterday = LocalDate.now().minusDays(1);
        yesterday = yesterday._year + '-' + addIntForDate(yesterday._month) + '-' + addIntForDate(yesterday._day);

        return {from: yesterday, to: today}
    }

    getLastWeek() {
        let startOfWeek = LocalDate.now().minusDays(7);
        startOfWeek = startOfWeek._year + '-' + addIntForDate(startOfWeek._month) + '-' + addIntForDate(startOfWeek._day)

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);

        return {from: startOfWeek, to: tomorrow}
    }


    getThisMonth() {
        let startOfMonth = LocalDate.now().withDayOfMonth(1)
            .format(DateTimeFormatter.ofPattern("yyyy-MM-dd"));

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return {from: startOfMonth, to: tomorrow}
    }

    getPreviousMonth() {
        let firstDayOfLastMonth = LocalDate.now().minusMonths(1);
        firstDayOfLastMonth = firstDayOfLastMonth._year+'-'+addIntForDate(firstDayOfLastMonth._month)+'-01'

        let now = LocalDate.now();
        let firstDayOfThisMonth = now._year + '-' + addIntForDate(now._month) + '-01';

        return { from : firstDayOfLastMonth,to : firstDayOfThisMonth}
    }

    getThisYear() {
        let startOfYear = LocalDate.now()._year + '-01-01'
        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return {from: startOfYear, to: tomorrow}
    }

    getForNoOfDays(noOfDays) {
        let startOfWeek = LocalDate.now().minusDays(noOfDays);
        startOfWeek = startOfWeek._year + '-' + addIntForDate(startOfWeek._month) + '-' + addIntForDate(startOfWeek._day)

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return {from: startOfWeek, to: tomorrow}
    }

    getDateDiff(date1, date2) {
        date1 = LocalDateTime.parse(date1 + ' 00:00:00', DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        date2 = LocalDateTime.parse(date2 + ' 00:00:00', DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        let duration = Duration.between(date1, date2);
        return duration.toDays();
    }

    isGreaterThanTwoMonths(range) {
        return this.getDateDiff(range.from, range.to) >= 60;
    }



}

export default TimeRangeManager = new TimeRangeManager();
export const dateTimeManager = {

    formatJavaDate(dateObject) {
        let date = dateObject.date;
        return `${date.year}-${formatDateNumber(date.month)}-${formatDateNumber(date.day)}`;
    },
    formatJavaDateTime(dateObject) {
        if (!dateObject) {
            return `Invalid Date`;
        }
        let date = dateObject.date;
        let time = dateObject.time;
        return `${date.year}-${formatDateNumber(date.month)}-${formatDateNumber(date.day)}T${formatDateNumber(time.hour)}:${formatDateNumber(time.minute)}`;
    },

    addHoursToDate(dateObject,duration) {
        if (!dateObject) {
            return `Invalid Date`;
        }

        if (!duration) {
            duration = 2;
        }
        let parsedDate = parseDate(dateObject);
        let date = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
            .plusHours(Number(duration));
        return formatCustomDateTime(date,defaultFormat);
    },
    addHoursToParsedDate(parsedDate,duration) {
        let date = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
            .plusHours(Number(duration));
        return formatCustomDateTime(date,defaultFormat);
    },



    dateForDisplay(dateObject) {
        let formattedDate = parseDate(dateObject)
        return new Date(formattedDate).toString().slice(3, 21);
    },
    shortenDisplay(dateObject) {
        let parsedDate = parseDate(dateObject);
        let formattedDate = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        let now = LocalDateTime.now()
        if (formattedDate.toLocalDate().equals(now.toLocalDate())) {
            return `Today at `+formatCustomDateTime(formattedDate,todayFormat)
        } else if (formattedDate.toLocalDate().year() === now.toLocalDate().year()) {
            return formatCustomDateTime(formattedDate,thisYearFormat)
        } else {
            return formatCustomDateTime(formattedDate,otherYearFormat)
        }
    },
    shortenStandardDisplay(parsedDate) {
        if (!parsedDate) return null;
        parsedDate = parsedDate.replaceAll("T"," ");
        // console.log({parsedDate})
        let formattedDate = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        let now = LocalDateTime.now()
        if (formattedDate.toLocalDate().equals(now.toLocalDate())) {
            return `Today at `+formatCustomDateTime(formattedDate,todayFormat)
        } else if (formattedDate.toLocalDate().year() === now.toLocalDate().year()) {
            return formatCustomDateTime(formattedDate,thisYearFormat)
        } else {
            return formatCustomDateTime(formattedDate,otherYearFormat)
        }
    },

    getStartOfThisMonth(){
        return formatCustomDateTime(LocalDateTime.now().withDayOfMonth(1),defaultFormat)
    },

    getNow() {
        return formatCustomDateTime(LocalDateTime.now(),defaultFormat);
    },

    getTomorrow() {
        return formatCustomDateTime(LocalDateTime.now().plusDays(1),defaultFormat);
    },

    getNext7Days() {
        return formatCustomDateTime(LocalDateTime.now().plusDays(7),defaultFormat);
    },

    getYesterday() {
        return formatCustomDateTime(LocalDateTime.now().minusDays(1),defaultFormat);
    },

    getNextMonthlyExpiryDate() {
        let dateString = formatCustomDateTime(LocalDateTime.now().plusMonths(1),defaultFormat).slice(0, -11) + '07';
        return handleDateExpiry(dateString);
    },

    getNextYearlyExpiryDate() {
        let dateString = formatCustomDateTime(LocalDateTime.now().plusYears(1),defaultFormat).slice(0, -11) + '07';
        return handleDateExpiry(dateString);
    },

    getTodayRange(){
        let today = LocalDate.now();
        today = today._year+'-'+addIntForDate(today._month)+'-'+addIntForDate(today._day);
        return { from : today,to : tomorrow}
    },

    getYesterdayRange(){
        let today = LocalDate.now();
        today = today._year+'-'+addIntForDate(today._month)+'-'+addIntForDate(today._day);

        let yesterday = LocalDate.now().minusDays(1);
        yesterday = yesterday._year+'-'+addIntForDate(yesterday._month)+'-'+addIntForDate(yesterday._day);
        return { from : yesterday,to : today}
    },

    getLastWeekRange(){
        let startOfWeek = LocalDate.now().minusDays(7);
        startOfWeek = startOfWeek._year+'-'+addIntForDate(startOfWeek._month)+'-'+addIntForDate(startOfWeek._day)
        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return { from : startOfWeek,to : tomorrow}
    },


    getLastMonthRange(){
        let firstDayOfLastMonth = LocalDate.now().minusMonths(1);
        firstDayOfLastMonth = firstDayOfLastMonth._year+'-'+addIntForDate(firstDayOfLastMonth._month)+'-01'

        let now = LocalDate.now();
        let firstDayOfThisMonth = now._year + '-' + addIntForDate(now._month) + '-01';

        return { from : firstDayOfLastMonth,to : firstDayOfThisMonth}
    },

    getThisMonthRange(){
        let now = LocalDate.now();
        let firstDayOfMonth = now._year + '-' + addIntForDate(now._month) + '-01';

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return { from : firstDayOfMonth,to : tomorrow}
    },

    getThisYearRange(){
        let startOfYear = LocalDate.now()._year+'-01-01'

        let tomorrow = LocalDate.now().plusDays(1);
        tomorrow = tomorrow._year + '-' + addIntForDate(tomorrow._month) + '-' + addIntForDate(tomorrow._day);
        return { from : startOfYear,to : tomorrow}
    },

    getNextTwoDaysForForm() {
        return formatCustomDateTime(LocalDateTime.now().plusDays(2),defaultFormat)
            .replace(' ', 'T')
            .slice(0, -3)
    },

    getNextWeekForForm() {
        return formatCustomDateTime(LocalDateTime.now().plusWeeks(1),defaultFormat)
            .replace(' ', 'T')
            .slice(0, -3)
    },


    timeAgo(dateObject, showAgoIfLonger) {
        let parsedDate = parseDate(dateObject);
        let date = LocalDateTime.parse(parsedDate, DateTimeFormatter.ofPattern("yyyy-MM-dd HH:mm:ss"))
        let now = LocalDateTime.now();
        let duration = Duration.between(date, now);
        if (duration.toDays() > 1) {
            // console.log("Duration greater than 1: " + duration.toDays())
        } else if (duration.toDays() === 1) {
            // console.log("Duration greater equal to 1: " + duration.toDays())
        } else {
            // console.log("Duration greater equal to 1: " + duration.toDays())
        }
    },

    hasDatePassed(date){
        let now = new Date();
        let other = new Date(date);
        return now > other;
    },


}
